module.exports = __webpack_public_path__ + "static/business-areas-md-d7dfa103b44b6dd269ea287f2efbbe4b.jpg";